import compare from '../../../utils/compare'

const state = {
  gsmc: "",
  //gsmc: "消费管理系统",
  company: null,
  currfun: {
    fun1: null,
    fun2: null,
    fun3: null
  },
  showBack: false,
  pages: [],
  tabs: [],
  currPage: {},
  currpageIndex: 0,
  theme: 'dark',
  collapsed: false,
  companyInfo: {},
  titlename:'',
}

const getters = {
  gsmc: state => state.gsmc,
  company: state => state.company,
  currfun: state => state.currfun,
  showBack: state => state.showBack,
  pages: state => state.pages,
  currPage: state => state.currPage,
  currpageIndex: state => state.currpageIndex,
  theme: state => state.theme,
  collapsed: state => state.collapsed,
  companyInfo: state => state.companyInfo,
  titlename: state => state.titlename,
}

const mutations = {
  setGsmc (state, gsmc) {
    console.log("setGsmc = " + gsmc,"titlename=",state.titlename);
	if (state.titlename== '')
		{document.title = `颜视通综合管理平台(${gsmc})`;}
	if (state.titlename== 'yktdemo')
		{document.title = `一卡通综合管理平台(${gsmc})`;}
	if (state.titlename== 'xfglxt')
		{document.title = `消费管理系统(${gsmc})`;}
	if (state.titlename== 'zhglpt')
		{document.title = `综合管理平台(${gsmc})`;}
	if (state.titlename== 'zhctglxt')
		{document.title = `智慧餐厅管理系统(${gsmc})`;}
	if (state.titlename== 'yltglpt')
		{document.title = `一脸通综合管理平台(${gsmc})`;}
	if (state.titlename== 'szstzhglpt')
		{document.title = `数字食堂综合管理平台(${gsmc})`;}
    //document.title = `消费管理系统(${gsmc})`;
    state.gsmc = gsmc;
  },
  setCompany (state, company) {
    state.company = company;
  },
  setFun (state, currfun) {
    state.currfun = currfun;
  },
  setShowBack (state, showBack) {
    state.showBack = showBack;
  },
  addPage (state, data) {
    let page = null;
    data.actived = true;
    for (let i = 0, len = state.pages.length; i < len; i++) {
      let tmp = state.pages[i];

      if (tmp.name === data.name && compare.deepEqual(tmp.params, data.params)) {
        page = tmp;
        tmp.actived = true;
        state.currpageIndex = i;
      } else {
        tmp.actived = false;
      }
    }
    if (page == null) {
      page = data;
      state.pages.push(data);
      state.currpageIndex = state.pages.length - 1;
    }
    state.currPage = page;
    // console.log("addPage currpageIndex = " + state.currpageIndex);
    // console.log("addPage  = " + JSON.stringify(state.pages));

  },
  removePage (state, index) {
    console.log("removePage index = " + index);
    state.currpageIndex = index == 0 ? 0 : index - 1;
    state.pages[state.currpageIndex].actived = true;
    state.pages.splice(index, 1);
    state.currPage = state.pages[state.currpageIndex];

    console.log("removePage size = " + state.pages.length);

  },
  choosePage (state, index) {
    if (state.currpageIndex == index) {
      return;
    }
    state.currpageIndex = index;
    for (let i = 0, len = state.pages.length; i < len; i++) {
      let tmp = state.pages[i];
      if (i == index) {
        state.currPage = tmp;
        tmp.actived = true;
      } else {
        tmp.actived = false;
      }
    }

  },
  clearPage (state) {
    state.pages = [],
      state.tabs = [],
      state.currPage = {}
  },
  setTheme (state, theme) {

    state.theme = theme;
  },
  setCollapsed (state, collapsed) {
    console.log("setCollapsed collapsed = " + collapsed);
    state.collapsed = collapsed;
  },
  setCompanyInfo (state, info) {
    state.companyInfo = info;
  },
  settitle (state, info) {
    state.titlename = info;
  }
}

const actions = {
  initCompany ({ commit }) {
    let companyStr = localStorage.getItem("ystadmin_company");
    // console.log("initCompany companyStr = " + companyStr);
    if (companyStr) {
      let company = JSON.parse(companyStr);
      commit("setCompany", company);
    }
    let cccinfoStr = localStorage.getItem("ystadmin_cccinfo");
    if (cccinfoStr) {
      let info = JSON.parse(cccinfoStr);
      commit("setCompanyInfo", info);
    }
  },
  clearCompany ({ commit }) {
    console.log("clearCompany clearData");
    localStorage.removeItem("ystadmin_company");
    localStorage.removeItem("ystadmin_cccinfo");
    commit("setCompany", null);
  },
  companyLogin ({ commit }, company) {
    commit("setCompany", company);
  },
  setFun ({ commit }, currfun) {
    commit("setFun", currfun);
  },
  setShowBack ({ commit }, showBack) {
    commit("setShowBack", showBack);
  },
  addPage ({ commit }, data) {
    commit("addPage", data);
  },
  removePage ({ commit }, data) {
    commit("removePage", data);
  },
  choosePage ({ commit }, data) {
    commit("choosePage", data);
  },
  clearPage ({ commit }) {
    commit("clearPage");
  },
  setGsmc ({ commit }, gsmc) {
    localStorage.setItem("ystadmin_gsmc", gsmc);
    commit("setGsmc", gsmc);
  },
  initGsmc ({ commit }) {
    let str = localStorage.getItem("ystadmin_gsmc");
    if (str) {
      commit("setGsmc", str);
    }
  },
  initTheme ({ commit }) {
    let themeStr = localStorage.getItem("ystadmin_theme");
    console.log("themeStr = " + themeStr);
    if (themeStr) {
      commit("setTheme", themeStr);
    }
  },
  setTheme ({ commit }, theme) {
    localStorage.setItem("ystadmin_theme", theme);
    commit("setTheme", theme);
  },
  setCollapsed ({ commit }, collapsed) {
    commit("setCollapsed", collapsed);
  },
  setCompanyInfo ({ commit }, info) {
    commit("setCompanyInfo", info);

    localStorage.setItem("ystadmin_cccinfo", JSON.stringify(info));
  },
  settitle ({ commit }, titlename) {
    localStorage.setItem("ystadmin_titlename", titlename);
    commit("settitle", titlename);
  },

}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/company/index.js